import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const httpApiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  // Only prepend API URL for relative URLs (not absolute URLs like Cognito)
  const isAbsoluteUrl = req.url.startsWith('http://') || req.url.startsWith('https://');

  if (isAbsoluteUrl) {
    // Don't modify absolute URLs (e.g., Cognito, external APIs)
    return next(req);
  }

  // Prepend API URL for relative URLs
  const apiReq = req.clone({
    url: `${environment.api}${req.url}`,
  });

  return next(apiReq);
};
